export default __webpack_public_path__ + "static/media/alberto-viera.d2ec66ae.png";